import React, { useState, useContext, useEffect } from "react";
import { RootContext } from "../../../RootContextProvider";
import { Button, message, Row, Col, Input, Form } from "antd";
import "./../../addNewLinkRegular/AddNewLinkRegular.css";
import { verticalFormLayout } from "../../../utils/forms";
import { addNewLinkToPage, updateLink, deleteLink } from "../../../utils/links";
import "../ModalLinkCreation.css";
import { FaLink } from "react-icons/fa";
import PlanLink from "../PlanLink";
import {
  isStatusAllowedToPush,
  validateLinkContent,
} from "../../../utils/utils";
import moment from "moment";
import momentTz from "moment-timezone";
import { DeleteOutlined, ArrowLeftOutlined } from "@ant-design/icons";

const BlockRegular = ({
  setModalOpen,
  isEdittingLink,
  setEdittingLink,
  linkEditDetails,
  currentLinks,
  setRefresh,
  refresh,
  setDisplayBlockPicker,
}) => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(true);
  const [isScheduled, setIsScheduled] = useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const { pages, account } = useContext(RootContext);

  useEffect(() => {
    const populateFields = () => {
      if (isEdittingLink) {
        console.log("editing mode");
        form.setFieldsValue({
          url: linkEditDetails.LinkUrl,
          title: linkEditDetails.LinkTitle,
          embedCode: linkEditDetails.LinkEmbedCode,
        });
        console.log(linkEditDetails);
        setLoading(false);
        if (linkEditDetails.IsScheduled) {
          setIsScheduled(true);
          setEndDate(moment(linkEditDetails.EndDate));
          setStartDate(moment(linkEditDetails.StartDate));
          setLoading(false);
        }
      } else {
        console.log("normal mode");
        form.setFieldsValue({
          url: "",
          title: "",
          embedCode: "",
        });
        setIsScheduled(false);
        setStartDate();
        setEndDate();
        setLoading(false);
        // form.resetFields();
      }
    };
    populateFields();
    // eslint-disable-next-line
  }, [isEdittingLink, linkEditDetails]);

  const onFinish = async (values) => {
    try {
      let isAllowedToPush = isStatusAllowedToPush(
        isScheduled,
        startDate,
        endDate
      );
      let validLinkContent = await validateLinkContent(
        values.url,
        account.IsPaying
      );
      console.log(validLinkContent);
      if (isAllowedToPush) {
        if (!validLinkContent.err) {
          if (!isEdittingLink) {
            let linkDetails = {
              type: "regular",
              title: values.title,
              url: values.url,
              embedCode: values.embedCode,
              index: currentLinks ? currentLinks.length : 0,
              isScheduled,
              startDate: momentTz(startDate).utc().format("YYYY-MM-DD HH:mm"),
              endDate: momentTz(endDate).utc().format("YYYY-MM-DD HH:mm"),
            };
            await addNewLinkToPage(pages.PageID, linkDetails);

            setRefresh(refresh + 1);
          } else {
            // update link info
            // close modal
            let linkDetails = {
              id: linkEditDetails.LinkID,
              type: linkEditDetails.LinkType,
              title: values.title,
              url: values.url,
              index: linkEditDetails.LinkIndex,
              isScheduled,
              startDate: momentTz(startDate).utc().format("YYYY-MM-DD HH:mm"),
              endDate: momentTz(endDate).utc().format("YYYY-MM-DD HH:mm"),
            };
            let isUpdated = await updateLink(pages.PageID, linkDetails);
            if (isUpdated.message) {
              message.success("Lien modifié avec succès");
              setEdittingLink(false);
              setRefresh(refresh + 1);
            } else {
              message.error("Erreur lors de la modification");
            }
          }
          setModalOpen(false);
        } else {
          message.warning(validLinkContent.err);
        }
      } else {
        message.warning(
          "Veuillez renseigner une date de début et fin à votre lien"
        );
      }
    } catch (e) {
      console.log(e);
      message.error("Erreur lors de l'ajout de votre lien");
    }
  };

  const onFinishFailed = async () => {
    console.log("Bugggg");
  };

  const delLink = async () => {
    let deletedLink = await deleteLink(pages.PageID, linkEditDetails.LinkID);

    if (deletedLink.message) {
      message.success("Lien supprimé avec succès");
      setRefresh(refresh + 1);
    } else {
      message.error("Erreur lors de la suppression");
    }
    cancelModal();
  };

  const cancelModal = () => {
    setModalOpen(false);
    setTimeout(() => {
      setEdittingLink(false);
    }, 200);
  };

  return (
    <div>
      <div className="modal-header">
        <Row>
          <Col span={2} className="back-link">
            {!isEdittingLink ? (
              <div
                onClick={() => {
                  setDisplayBlockPicker(true);
                }}
              >
                <ArrowLeftOutlined style={{ marginRight: "5px" }} />
              </div>
            ) : (
              ""
            )}
          </Col>
          <Col span={20}>
            <div className="modal-title">
              <FaLink className="icon-modal-title" /> Paramètrez votre lien
            </div>
          </Col>
          <Col span={2}>
            {/* <div
              onClick={() => {
                setDisplayBlockPicker(true);
              }}
            >
              <ArrowLeftOutlined style={{ marginRight: "5px" }} />
            </div> */}
            {/* {isEdittingLink ? (
              <img
                src={iconDelete}
                onClick={() => {
                  delLink();
                }}
                atl="icon delete"
                width="30px"
                style={{ float: "right", cursor: "pointer" }}
              />
            ) : (
              ""
            )} */}
          </Col>
        </Row>
      </div>
      <div className="modal-body">
        <Form
          className="form-signup align-left"
          layout="vertical"
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          {...verticalFormLayout}
        >
          {/* <Form.Item
            label="Icône"
            name="icon"
            // maxLength={80}
            // rules={[{ required: true, message: "Insérez votre titre" }]}
          ></Form.Item> */}
          <Form.Item
            label="Titre du lien"
            name="title"
            rules={[
              { required: true, message: "Insérez votre titre" },
              {
                max: 35,
                message: "Votre titre doit faire 35 caractères maximum.",
              },
            ]}
          >
            <Input
              className="auth-input"
              placeholder="Mon super lien"
              maxLength={35}
            />
          </Form.Item>
          <Form.Item
            label="URL du lien"
            name="url"
            rules={[
              { required: true, message: "Insérez votre url" },
              { type: "url", message: "Veuillez entrer une URL valide." },
              {
                max: 400,
                message: "Votre URL doit faire maximum 400 caractères",
              },
            ]}
          >
            <Input className="auth-input" placeholder="https://monsite.com" />
          </Form.Item>
          {/* <Form.Item
            name="boost"
            // rules={[{ required: true, message: "Insérez votre url" }]}
          >
            <div className="animate-link-section">
              {" "}
              <Switch />
              <div style={{ marginLeft: "10px" }}>
                Animation pour faire ressortir le lien
              </div>
            </div>
          </Form.Item> */}
          {!loading ? (
            <PlanLink
              isScheduled={isScheduled}
              setIsScheduled={setIsScheduled}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              startDate={startDate}
              endDate={endDate}
              // loading={loading}
            />
          ) : (
            ""
          )}
          <Form.Item style={{ textAlign: "center", marginTop: "20px" }}>
            <Button
              className="submit-link"
              htmlType="submit"
              loading={loading}
              size="large"
            >
              Sauvegarder
            </Button>
            {isEdittingLink ? (
              <div
                className="del-link-mobile"
                onClick={() => {
                  delLink();
                }}
              >
                <DeleteOutlined style={{ marginRight: "5px" }} />
                Supprimer
              </div>
            ) : (
              ""
            )}
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default BlockRegular;
